"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecimalCoder = void 0;
const decimal_js_1 = require("decimal.js");
exports.DecimalCoder = {
    testDecode: (object) => typeof object === "string" && /^[0-9]+(\.[0-9]+)?d$/.test(object),
    decode: (object) => new decimal_js_1.Decimal(object.substr(0, object.length - 1)),
    testEncode: (object) => decimal_js_1.Decimal.isDecimal(object),
    encode: (object) => object.toString() + "d",
};
//# sourceMappingURL=decimal.js.map